module.exports = __webpack_public_path__ + "static/img/feedback-grouping.37ffd292.png";